const toCents = (value) =>
  Math.round(Math.abs(Number(value) || 0) * 100) / 100;

export const getPromotionDetails = (charges) =>
  Array.isArray(charges?.promotionDetails) ? charges.promotionDetails : [];

export const promotionCodeOf = (promotion) =>
  String(promotion?.promotionCode || "").trim();

export const isCodedPromotion = (promotion) =>
  Boolean(promotionCodeOf(promotion));

const promotionAmountOf = (promotion) =>
  toCents(promotion?.discountAmount);

const toLine = (promotion, index) => {
  const code = promotionCodeOf(promotion);
  return {
    key:
      promotion?.promotionUuid ||
      promotion?.uuid ||
      `${code || "promo"}-${index}`,
    code,
    label:
      String(
        promotion?.displayLabel || promotion?.promotionName || code,
      ).trim() || code,
    amount: promotionAmountOf(promotion),
  };
};

const sumAmounts = (lines) =>
  toCents(lines.reduce((total, line) => total + (line.amount || 0), 0));

export const getPromotionSummary = (charges) => {
  const details = getPromotionDetails(charges);
  const coupons = [];
  const promotions = [];

  details.forEach((promotion, index) => {
    const line = toLine(promotion, index);
    if (line.code) {
      coupons.push(line);
      return;
    }
    promotions.push(line);
  });

  const couponAmount = sumAmounts(coupons);
  let groupedAmount = sumAmounts(promotions);

  if (details.length) {
    const leftover = toCents(toCents(charges?.promotionDiscount) - couponAmount);
    if (promotions.length && groupedAmount === 0 && leftover > 0) {
      groupedAmount = leftover;
    }
  } else {
    groupedAmount = toCents(charges?.promotionDiscount);
  }

  return {
    coupons: coupons.filter((line) => line.amount > 0),
    promotions: promotions.filter((line) => line.amount > 0),
    groupedAmount,
    hasPromotionDetails: details.length > 0,
  };
};

export const resolvePromotionDetailsFromOrder = (orderData) =>
  getPromotionDetails(orderData?.charges);
